import React, { useContext, useEffect, useState, useRef } from 'react'
import { dataContext, localestr, itemToText, toText, getIrgValue, uid } from '../utils.js'
import EditCtrl from '../cmp/EditCtrl.js'
import Menu from '../cmp/menu'
import UniTable from '../cmp/UniTable'
import FilterForm from '../cmp/FilterForm' //+
import Modifiers from '../cmp/Modifiers'
import Panel from '../cmp/Panel'
import icon from '../icons.svg'

let loading = false

let buffer = ''
let timer = null
let findDlg = false

function DocOrderEdit({ data, actions }) {
  const targetRef = useRef()
  let wndData = {}
  if (data) wndData = data.wndData
  else wndData = actions.getWndData()
  const setWndData = actions.setWndData
  const tabNew = actions.tabNew
  const tabClose = actions.tabClose
  const tblPos = actions.tblPos  //Таблиця
  const isActive = actions.isActive  //Таблиця
  const setGlData = actions.setGlData
  const getGlData = actions.getGlData

  const context = useContext(dataContext)
  //const getData=context.getData
  //const saveData=context.saveData
  const addTWnd = context.addTWnd
  const newTWnd = context.newTWnd
  const msg = context.msg
  const loaddata = context.loaddata
  const inputNumber = context.inputNumber
  const inputWeight = context.inputWeight
  const getSettings = context.getSettings
  const setSettings = context.setSettings
  const usersettings = getSettings().docOdrerEdit
  const inputCols = context.inputCols
  const msg_arr = context.msg_arr

  const catGoods = context.data['catGoods']
  const fldGoods = context.data['fldGoods']
  const sysConst = context.data['sysConst'] || {}
  const selYN = context.data['selYN']
  const selOrderStatus = context.data['selOrderStatus']
  const selectionType = getSettings().selectionType || '0'
  const urAdmin = parseInt((context.user || {}).urAdmin || 0)
  const isAuthor = (context.user || {}).id===(wndData.author || {}).id
  let posted = parseInt(wndData.posted || 0) && !urAdmin
  let minDate = (new Date()).toISOString()
  if((context.user || {}).rights?.urDocs3Edit){
    let d = new Date()
    d.setDate(d.getDate() - 3)
    if(minDate > d.toISOString()) minDate = d.toISOString()
  }
  if((context.user || {}).rights?.urDocs7Edit){
    let d = new Date()
    d.setDate(d.getDate() - 7)
    if(minDate > d.toISOString()) minDate = d.toISOString()
  }
  if((context.user || {}).rights?.urDocsREdit){
    if(context.last_rev && context.last_rev < minDate) minDate = context.last_rev
  }
  if(urAdmin){
    let d = new Date()
    d.setDate(d.getDate() - 1095) // 3 роки взад
    if(minDate > d.toISOString()) minDate = d.toISOString()
  }
  if(posted){
    if(wndData.date && wndData.date > minDate){
      if(isAuthor && (context.user || {}).rights?.urDocsOEdit) posted=false  // автор може редагувати свої документи, але врахувати останню ревізію чи дату
      if((context.user || {}).rights?.urDocsSEdit) posted=false  // автор може редагувати чужі документи, але врахувати останню ревізію чи дату
    }
  }

  //const [edit, setEdit] = useState(false)
  const edit = (getGlData() || {}).edit
  const setEdit = (d) => { setGlData({ edit: d }) }
  const [isActive2, setisActive] = useState(false)
  const cols = [
    { caption: '№', minWidth: '20', maxWidth: '25', dataId: 'docum', sortable: false, typeVal: 'submit', setFn: (d) => { saveValue(d) } },
    //{caption:'№',minWidth:'40',dataId:'id',sortable:true},
    { caption: localestr('Меню'), minWidth: '70', dataId: 'menu', sortable: true, typeVal: 'catGoods', setFn: (d) => { setVal('menu', d) } },
    { caption: localestr('Модифікатори'), minWidth: '70', dataId: 'modifiers', sortable: true },
    { caption: localestr('К-сть'), minWidth: '40', maxWidth: '75', dataId: 'sum_qtt', sortable: true, typeVal: 'number3', setFn: (d) => { setVal('sum_qtt', d) } },
    { caption: localestr('Ціна'), minWidth: '40', maxWidth: '75', dataId: 'sum_prc', sortable: true, typeVal: 'number2', setFn: (d) => { setVal('sum_prc', d) } },
    { caption: localestr('Сума +'), minWidth: '55', maxWidth: '75', dataId: 'sum_bruto', sortable: true, typeVal: 'number2', setFn: (d) => { setVal('sum_bruto', d) } },
    { caption: localestr('Знижка'), minWidth: '50', maxWidth: '75', dataId: 'sum_discount', sortable: true, typeVal: 'number2', setFn: (d) => { setVal('sum_discount', d) } },
    { caption: localestr('Сума -'), minWidth: '55', maxWidth: '75', dataId: 'sum_amount', sortable: true },
    { caption: localestr('Коментар'), minWidth: '40', dataId: 'comment', sortable: true, typeVal: 'text', setFn: (d) => { setVal('comment', d) } },
    { caption: localestr('Відмова'), minWidth: '25', maxWidth: '65', dataId: 'refuse', sortable: true, typeVal: 'selYN', setFn: (d) => { setVal('refuse', d) } },
    { caption: localestr('Причина'), minWidth: '45', dataId: 'reason', sortable: true, typeVal: 'catReasons', setFn: (d) => { setVal('reason', d) } },
    { caption: localestr('Статус'), minWidth: '45', dataId: 'status', sortable: true, typeVal: 'selOrderStatus', setFn: (d) => { setVal('status', d) } },
    { caption: localestr('Марка 1'), minWidth: '40', dataId: 'mark1', sortable: true, typeVal: 'text', setFn: (d) => { setVal('mark1', d) } },
    { caption: localestr('%'), minWidth: '40', dataId: 'sum_qtt1', sortable: true, typeVal: 'number2', setFn: (d) => { setVal('sum_qtt1', d) } },
    { caption: localestr('Марка 2'), minWidth: '40', dataId: 'mark2', sortable: true, typeVal: 'text', setFn: (d) => { setVal('mark2', d) } },
    { caption: localestr('%'), minWidth: '40', dataId: 'sum_qtt2', sortable: true, typeVal: 'number2', setFn: (d) => { setVal('sum_qtt2', d) } },
    { caption: localestr('Марка 3'), minWidth: '40', dataId: 'mark3', sortable: true, typeVal: 'text', setFn: (d) => { setVal('mark3', d) } },
    { caption: localestr('%'), minWidth: '40', dataId: 'sum_qtt3', sortable: true, typeVal: 'number2', setFn: (d) => { setVal('sum_qtt3', d) } },
    { caption: localestr('Марка 4'), minWidth: '40', dataId: 'mark4', sortable: true, typeVal: 'text', setFn: (d) => { setVal('mark4', d) } },
    { caption: localestr('%'), minWidth: '40', dataId: 'sum_qtt4', sortable: true, typeVal: 'number2', setFn: (d) => { setVal('sum_qtt4', d) } },
    { caption: localestr('Марка 5'), minWidth: '40', dataId: 'mark5', sortable: true, typeVal: 'text', setFn: (d) => { setVal('mark5', d) } },
    { caption: localestr('%'), minWidth: '40', dataId: 'sum_qtt5', sortable: true, typeVal: 'number2', setFn: (d) => { setVal('sum_qtt5', d) } },
    { caption: localestr('В чек'), minWidth: '40', dataId: 'excise_mark', sortable: true, typeVal: 'text', setFn: (d) => { setVal('excise_mark', d) } },
    { caption: localestr('РРО'), minWidth: '45', dataId: 'fiscal', sortable: true, typeVal: 'catDevices', setFn: (d) => { setVal('fiscal', d) } },
    { caption: localestr('Соб-ть'), minWidth: '45', maxWidth: '55', dataId: 'sum_cost', sortable: true },
  ]

  if (usersettings && usersettings.cols) {
    for (let i = 0; i < usersettings.cols.length; i++) {
      const idx = cols.findIndex(el => el.dataId === usersettings.cols[i])
      if (idx !== -1) cols[idx].hiden = true
    }
  } else {
    cols[2].hiden = true
    cols[5].hiden = true
    cols[8].hiden = true
    cols[9].hiden = true
    cols[10].hiden = true
    //cols[11].hiden=true
    cols[12].hiden = true
    cols[13].hiden = true
    cols[14].hiden = true
    cols[15].hiden = true
    cols[16].hiden = true
    cols[17].hiden = true
    cols[18].hiden = true
    cols[19].hiden = true
    cols[20].hiden = true
    cols[21].hiden = true
    cols[22].hiden = true
    cols[24].hiden = true
  }

  const filterData = [ //+
    { caption: localestr('Меню'), dataId: 'menu', typeVal: 'catGoods' },
    { caption: localestr('К-сть'), dataId: 'sum_qtt', typeVal: 'number' },
    { caption: localestr('Ціна'), dataId: 'sum_prc', typeVal: 'number' },
    { caption: localestr('Сума +'), dataId: 'sum_bruto', typeVal: 'number' },
    { caption: localestr('Знижка'), dataId: 'sum_discount', typeVal: 'number' },
    { caption: localestr('Сума -'), dataId: 'sum_amount', typeVal: 'number' },
    { caption: localestr('Коментар'), dataId: 'comment', typeVal: 'text' },
    { caption: localestr('Відмова'), dataId: 'refuse', typeVal: 'selYN' },
    { caption: localestr('причина'), dataId: 'reason', typeVal: 'selYN' },
    { caption: localestr('Статус'), dataId: 'status', typeVal: 'selOrderStatus' }
  ]

  const setFilter = (id, val, type) => {
    let filter = [...(wndData.filter || [])]
    const idx = filter.findIndex(el => el.dataId === id)
    if (idx !== -1) {
      if (!val) filter.splice(idx, 1)
      else filter[idx].value = val
    } else if (val) filter.push({ dataId: id, compare: 'lk', value: val, typeVal: type })
    if (!filter.length) filter = undefined
    setWndData({ ...wndData, filter, currentCol: undefined })
    setGlData({ needFocus: 1 })
    tblPos(0)
  }

  const showHideFilter = () => {
    const showAFilter = !wndData.showAFilter
    if (!showAFilter) setWndData({ ...wndData, filter: undefined, showAFilter })
    else setWndData({ ...wndData, showAFilter })
  }

  const listFromData = (currentCol, setCurrCol) => {
    let list = []
    if (wndData.table) list = wndData.table.map((item) => {
      let curr_mods = []
      function addParrentMods(parent) {
        if (!parent) return
        if (!parent.id) return
        const fld = (fldGoods || []).find(el => el.id === parent.id)
        if (fld) {
          if (fld.modifiers) curr_mods = curr_mods.concat(fld.modifiers)
          addParrentMods(fld.parent)
        }
      }

      const newItem = {
        uid: uid(),
        id: item.id,
        menu: { id: item.menu_id, name: item.name, menu_name: item.menu, parent: { id: item.menu_pid }, department: { id: item.department_id, name: item.department } },
        modifiers: item.modifiers || null,
        sum_qtt: item.qtt,
        sum_amount: item.amount,
        sum_discount: item.discount,
        sum_bruto: ((parseFloat(item.amount) || 0) + (parseFloat(item.discount) || 0)).toFixed(2),
        sum_prc: (((parseFloat(item.amount) || 0) + (parseFloat(item.discount) || 0)) / item.qtt).toFixed(2),
        comment: item.comment,
        refuse: selYN.find(x => x.value === (item.refuse || '0')),
        reason: { id: item.reason_id, name: item.reason },
        status: selOrderStatus.find(x => x.value === item.status),
        sum_cost: item.cost,
        excise_mark: item.excise_mark,
        mark1: item.mark1,
        sum_qtt1: item.qtt1 ? (item.qtt1 / 100).toFixed(2) : '',
        mark2: item.mark2,
        sum_qtt2: item.qtt2 ? (item.qtt2 / 100).toFixed(2) : '',
        mark3: item.mark3,
        sum_qtt3: item.qtt3 ? (item.qtt3 / 100).toFixed(2) : '',
        mark4: item.mark4,
        sum_qtt4: item.qtt4 ? (item.qtt4 / 100).toFixed(2) : '',
        mark5: item.mark5,
        sum_qtt5: item.qtt5 ? (item.qtt5 / 100).toFixed(2) : '',
        fiscal: { id: item.fiscal_id, name: item.fiscal }
      }
      if (item.fiscal_id === '9999') newItem.fiscal = { id: item.fiscal_id, name: localestr('Заброньовано') }
      const menu_item = (catGoods || []).find(el => el.id === item.menu_id)
      if (menu_item) {
        newItem.menu = { ...menu_item }
        if (menu_item.modifiers) curr_mods = [...menu_item.modifiers]
        addParrentMods(menu_item.parent)
        if (curr_mods.length) newItem.curr_mods = curr_mods
      }
      if (item.edit) newItem.edit = true
      if (typeof currentCol !== 'undefined' && currentCol.id === item.id) setCurrCol(newItem)
      return newItem
    })
    return list
  }

  const sortList = (col, sort, list) => {
    let needUpd = false
    let currentCol = wndData.currentCol
    if (typeof list === 'undefined') { list = listFromData(currentCol, newCol => currentCol = newCol); needUpd = true }
    else if (typeof wndData.list === 'undefined') { list = listFromData(currentCol, newCol => currentCol = newCol); needUpd = true }
    else list = wndData.list.slice()

    list.sort((a, b) => {
      let vala = toText(a[col])
      let valb = toText(b[col])
      if (col === 'id') {
        vala = parseInt(vala)
        valb = parseInt(valb)
      } else if (col === 'date') {
        vala = (a[col])
        valb = (b[col])
      } else if (col.substring(0, 4) === 'sum_') {
        vala = parseFloat(a[col] || 0)
        valb = parseFloat(b[col] || 0)
      } else {
        vala = vala.toLowerCase()
        valb = valb.toLowerCase()
      }
      if (sort === 'asc') {
        if (vala < valb) { needUpd = true; return -1 }
        if (vala > valb) return 1
        return 0
      } else if (sort === 'desc') {
        if (vala < valb) return 1
        if (vala > valb) { needUpd = true; return -1 }
        return 0
      } else return 0
    })
    const sorting = { dataId: col, sort: sort }
    if (needUpd || wndData.sorting.dataId !== col || wndData.sorting.sort !== sort) setWndData({ ...wndData, list, sorting, currentCol })
  }

  const getUsedDiscounts = (arr, uid) => {
    let used_discounts = 0
    if (arr && arr.length) {
      arr.forEach(el => {
        if (!el.hide && !parseInt(el.refuse?.value || 0) && uid !== el.uid) used_discounts += parseFloat(el.sum_discount || 0)
      })
    }
    return used_discounts
  }

  const setHidenCols = (data) => {
    if (data) {
      const new_data = data.filter(el => el.hiden).map(el => el.dataId)
      setSettings({ docOdrerEdit: { cols: new_data } })
    } else {
      if (edit) return
      inputCols(cols, setHidenCols)
    }
  }

  const setCol = (currentCol) => {
    if (!posted) setisActive(true)
    if (wndData.currentCol) if (currentCol.uid === wndData.currentCol.uid) return
    if ((getGlData() || {}).edit) { saveValue(() => { setCol(currentCol) }); return }
    //const list=wndData.list
    //const sorting=wndData.sorting
    //setWndData({...wndData,currentCol})
    const oldCol = { ...currentCol }
    setWndData({ ...wndData, currentCol, oldCol })

    setGlData({ needFocus: 0 })
  }

  const setVal = (name, data) => {
    let currentCol = wndData.currentCol
    if (name === 'sum_qtt_w') name = 'sum_qtt'
    if (name === 'fiscal' && data) {
      if (data.device && parseInt(data.device.value) < 4) {
        msg(localestr('Недопустимий тип пристрою'), localestr('Помилка'), [{ caption: 'OK', action: () => { } }])
        return
      }
    }
    currentCol[name] = data
    if (name === 'menu') {
      let price_delta = 0
      if (data.modifiers) data.modifiers.forEach(el => price_delta += parseFloat(el.price) || 0)
      let sum_prc = parseFloat(data.sum_out || 0) + price_delta
      if (data.price_history_out) sum_prc = parseFloat(getIrgValue(wndData.date, data.price_history_out) || 0)
      const sum_qtt = parseFloat(currentCol.sum_qtt || 1)
      let sum_bruto = sum_prc * sum_qtt
      let sum_discount = parseFloat(currentCol.sum_discount || 0)
      let discount_mode = 0
      let disc_type = 0
      if (wndData.discount) disc_type = parseInt(wndData.discount.type || 0)
      if (disc_type === 0) { //Звичайна знижка
        if (wndData.discount && wndData.discount.price_history) sum_discount = getIrgValue(wndData.date, wndData.discount.price_history) * sum_bruto / 100
      } else if (disc_type === 2) { //Місячна знижка
        if (wndData.discount && wndData.discount.price_history) sum_discount = (wndData.discount.sum_bal || getIrgValue(wndData.date, wndData.discount.price_history)) - getUsedDiscounts(wndData.list, currentCol.uid)
      }
      if (sum_discount > sum_bruto) sum_discount = sum_bruto
      if (wndData.discount && wndData.discount.mode) discount_mode = wndData.discount.mode
      if (data.disable_discount && parseInt(data.disable_discount)) sum_discount = 0
      if (discount_mode) { sum_bruto = sum_bruto - sum_discount; sum_prc = sum_bruto / (sum_qtt || 1); sum_discount = 0 }
      currentCol.sum_prc = sum_prc.toFixed(2)
      currentCol.sum_qtt = sum_qtt.toFixed(3)
      currentCol.sum_bruto = sum_bruto.toFixed(2)
      currentCol.sum_discount = sum_discount.toFixed(2)
      currentCol.sum_amount = (sum_bruto - sum_discount).toFixed(2)
      currentCol.refuse = selYN[1]
      currentCol.status = selOrderStatus[1]
    } else if (name === 'sum_qtt') {
      const sum_prc = parseFloat(currentCol.sum_prc || 0)
      const sum_qtt = parseFloat(data || 0)
      const sum_bruto = sum_prc * sum_qtt
      let sum_discount = parseFloat(currentCol.sum_discount || 0)
      if (wndData.discount && wndData.discount.price_history && !wndData.discount.mode) sum_discount = parseFloat(getIrgValue(wndData.date, wndData.discount.price_history) || 0) * sum_bruto / 100
      if (currentCol.menu.disable_discount && parseInt(currentCol.menu.disable_discount)) sum_discount = 0
      if (sum_discount > sum_bruto) sum_discount = sum_bruto
      currentCol.sum_bruto = sum_bruto.toFixed(2)
      currentCol.sum_discount = sum_discount.toFixed(2)
      currentCol.sum_amount = (sum_bruto - sum_discount).toFixed(2)
    } else if (name === 'sum_prc') {
      const sum_prc = parseFloat(data || 0)
      const sum_qtt = parseFloat(currentCol.sum_qtt || 0)
      const sum_bruto = sum_prc * sum_qtt
      let sum_discount = parseFloat(currentCol.sum_discount || 0)
      if (wndData.discount && wndData.discount.price_history && !wndData.discount.mode) sum_discount = parseFloat(getIrgValue(wndData.date, wndData.discount.price_history) || 0) * sum_bruto / 100
      if (currentCol.menu.disable_discount && parseInt(currentCol.menu.disable_discount)) sum_discount = 0
      if (sum_discount > sum_bruto) sum_discount = sum_bruto
      //currentCol.sum_prc=sum_prc.toFixed(2)
      currentCol.sum_bruto = sum_bruto.toFixed(2)
      currentCol.sum_discount = sum_discount.toFixed(2)
      currentCol.sum_amount = (sum_bruto - sum_discount).toFixed(2)
    } else if (name === 'sum_bruto') {
      const sum_bruto = parseFloat(data || 0)
      const sum_qtt = parseFloat(currentCol.sum_qtt || 0)
      let sum_prc = parseFloat(currentCol.sum_prc || 0)
      if (sum_qtt) sum_prc = sum_bruto / sum_qtt
      let sum_discount = parseFloat(currentCol.sum_discount || 0)
      if (wndData.discount && wndData.discount.price_history && !wndData.discount.mode) sum_discount = parseFloat(getIrgValue(wndData.date, wndData.discount.price_history) || 0) * sum_bruto / 100
      if (currentCol.menu.disable_discount && parseInt(currentCol.menu.disable_discount)) sum_discount = 0
      if (sum_discount > sum_bruto) sum_discount = sum_bruto
      currentCol.sum_prc = sum_prc.toFixed(2)
      //currentCol.sum_bruto=sum_bruto.toFixed(2)
      currentCol.sum_discount = sum_discount.toFixed(2)
      currentCol.sum_amount = (sum_bruto - sum_discount).toFixed(2)
    } else if (name === 'sum_discount') {
      const sum_bruto = parseFloat(currentCol.sum_bruto || 0)
      const sum_discount = Math.min(parseFloat(data || 0), sum_bruto)
      //currentCol.sum_discount=sum_discount.toFixed(2)
      currentCol.sum_amount = (sum_bruto - sum_discount).toFixed(2)
    }
    setWndData({ ...wndData, currentCol })
    setEdit(true)
  }

  /*const cancelEdit=()=>{
      //const currentCol={...wndData.currentCol.cancel}
      //setWndData({...wndData,currentCol})
      
      setEdit(false)
      if(!wndData.currentCol.menu && !wndData.currentCol.qtt){
          const list=wndData.list.filter(el=>el.uid!==wndData.currentCol.uid)
          setWndData({...wndData,list,currentCol:undefined})
      }
      setTimeout(()=>sortList(wndData.sorting.dataId,wndData.sorting.sort,wndData.list),25)
  }*/
  const cancelEdit = () => {
    if (!isActive()) return
    setEdit(false)
    setisActive(false)
    setGlData({ lastCol: 0, needFocus: 0 })
    const newData = actions.getWndData()
    if (newData.oldCol) {
      newData.currentCol = { ...newData.oldCol }
      newData.oldCol = undefined
      newData.list = newData.list.map(el => el.uid !== newData.currentCol.uid ? el : { ...newData.currentCol })
      setWndData(newData)
    } else {
      const list = newData.list.filter(el => el.uid !== newData.currentCol.uid)
      setWndData({ ...wndData, list, currentCol: undefined, oldCol: undefined })
    }
  }

  const filter = (fltr) => {
    let showFilter = !wndData.showFilter
    let filter = wndData.filter
    if (fltr !== undefined) filter = fltr
    if (showFilter || fltr === undefined) setWndData({ ...wndData, showFilter, filter })
    else {
      setWndData({ ...wndData, showFilter, filter, currentCol: undefined })
      setGlData({ needFocus: 1 })
      tblPos(0)
    }
  }

  const setValue = (name, data) => {
    if (posted) return
    setisActive(false)
    let newData = { ...wndData }
    // перевірити чи дата у минулому більше за 90 днів
    // перевірити чи дата у майбутньому
    if (name === 'date') {
      const currentDay = new Date();
      currentDay.setHours(23, 59, 59, 99);
      const inputDay = new Date(data);
      if (inputDay > currentDay) msg(localestr("Цей день ще не настав!"), localestr('Попередження'), [{ caption: 'OK', action: () => { } }]);
      else if ((currentDay - inputDay) / (1000 * 60 * 60 * 24) > 90) msg(localestr("У вас дуже стара дата!"), localestr('Попередження'), [{ caption: 'OK', action: () => { } }]);
    }
    if (name === 'docType') {
      if (data !== '1') {
        newData.courier = null
        newData.reward = null
      }
    }
    if (data === '') newData[name] = null
    else newData[name] = data
    if (name === 'discount') {
      let prc_discount = 0
      let oldprc_discount = 0
      let old_mode = 0
      let new_mode = 0
      let disc_type = 0
      let sum_bal = 0
      if (wndData.discount && wndData.discount.mode) old_mode = parseInt(wndData.discount.mode || 0)
      if (data && data.mode) new_mode = parseInt(data.mode || 0)
      if (data) {
        prc_discount = parseFloat(data.prc || 0)
        if (data.price_history) prc_discount = getIrgValue(wndData.date, data.price_history) || 0
        disc_type = parseInt(data.type || 0)
        sum_bal = parseFloat(data.sum_bal || prc_discount)
      }
      if (wndData.discount) {
        oldprc_discount = parseFloat(wndData.discount.prc || 0)
        if (wndData.discount.price_history) oldprc_discount = getIrgValue(wndData.date, wndData.discount.price_history)
      }
      let list = newData.list
      if (disc_type === 2) {
        list.forEach(el => { el.sum_discount = '0.00'; el.sum_amount = el.sum_bruto; })
      }

      list.forEach(el => {
        let sum_bruto = parseFloat(el.sum_bruto || 0)
        if (old_mode !== 0 && oldprc_discount < 100) sum_bruto = sum_bruto * 100 / (100 - oldprc_discount)
        let sum_discount = 0
        if (disc_type === 0) sum_discount = prc_discount * sum_bruto / 100
        else if (disc_type === 2) sum_discount = sum_bal - getUsedDiscounts(list, el.uid)
        if (sum_discount > sum_bruto) sum_discount = sum_bruto
        const sum_qtt = parseFloat(el.sum_qtt || 1)
        let sum_prc = parseFloat(el.sum_prc || 0)
        if (old_mode !== 0) sum_prc = sum_bruto / sum_qtt
        if (new_mode !== 0) { sum_bruto = sum_bruto - sum_discount; sum_discount = 0; sum_prc = sum_bruto / sum_qtt }
        const sum_amount = sum_bruto - sum_discount
        if (el.sum_amount !== sum_amount.toFixed(2) || el.sum_bruto !== sum_bruto.toFixed(2)) {
          el.sum_prc = sum_prc.toFixed(2)
          el.sum_bruto = sum_bruto.toFixed(2)
          el.sum_discount = sum_discount.toFixed(2)
          if (el.menu.disable_discount && parseInt(el.menu.disable_discount)) sum_discount = 0
          el.sum_amount = (sum_amount).toFixed(2)
          el.edit = true
        }
      })
      newData.list = list
    }
    if (!newData.edit) newData.edit = true
    setWndData(newData, true)
  }

  const saveValue = (act = null) => {
    if (!isActive()) return
    let errmsg = ''
    const currCol = { ...wndData.currentCol, edit: true }
    const list = wndData.list
    if (!currCol) return
    currCol.refuse = typeof currCol.refuse === 'object' ? currCol.refuse : selYN.find(x => x.value === (currCol.refuse || '0'))
    currCol.status = typeof currCol.status === 'object' ? currCol.status : selOrderStatus.find(x => x.value === (currCol.status || '0'))
    if (!currCol.menu && !currCol.hide) errmsg = localestr("Не заповнено меню")
    if (!currCol.sum_qtt && !currCol.sum_bruto) errmsg = localestr("Не заповнено кількість або суму")
    if (errmsg !== '') msg(errmsg, localestr('Помилка'), [{ caption: 'OK', action: () => { } }])
    else {
      currCol.sum_qtt = parseFloat(currCol.sum_qtt).toFixed(3)
      if (!currCol.refuse) currCol.reason = { id: null, name: null }
      else if (!parseInt(currCol.refuse.value)) currCol.reason = { id: null, name: null }
      const idx = list.findIndex(el => el.uid === currCol.uid)
      if (idx === -1) list.push(currCol)
      else list[idx] = currCol
      let newData = { ...wndData, list }
      setWndData(newData, true)
      setEdit(false)
      setisActive(false)
      if (act === -1) setGlData({ lastCol: 0, needFocus: 0 })
      else if (act) setTimeout(() => { act() }, 100)
    }
  }

  const newItem = () => {
    if (posted) return
    if ((getGlData() || {}).edit) { saveValue(() => { newItem() }); return }
    //if (edit) return
    setisActive(true)
    let currentCol = { id: '', uid: uid() }
    const list = wndData.list.concat(currentCol)
    setWndData({ ...wndData, list, currentCol })
    setGlData({ lastCol: 0, needFocus: 0 })
    setEdit(true)
  }

  const copyItem = () => {
    if (posted) return
    if ((getGlData() || {}).edit) { saveValue(() => { copyItem() }); return }
    //if (edit) return
    if (typeof wndData.currentCol === 'object') {
      setisActive(true)
      let currentCol = { ...wndData.currentCol, uid: uid() }
      //todo перерахвати знижку якщо вона місячна сума
      delete currentCol.id
      const list = wndData.list.concat(currentCol)
      setWndData({ ...wndData, list, currentCol })
      setGlData({ needFocus: 0, lastCol: 0 })
      setEdit(true)
    }
  }

  const editItem = () => {
    return
    /*if(posted) return
    if (edit) return
    if (!wndData.currentCol) return
    const currentCol={...wndData.currentCol}
    const oldCol={...wndData.currentCol}
    setWndData({...wndData,currentCol,oldCol})
    setEdit(true)*/
  }

  const editClick = () => {
    if (typeof wndData.currentCol === 'object') editItem()
  }

  const selectionClick = () => {
    if (posted) return
    if ((getGlData() || {}).edit) { saveValue(() => { selectionClick() }); return }
    let curVall = undefined
    if (wndData.currentCol) curVall = wndData.currentCol.menu
    if (!curVall) addTWnd(localestr('Вибір'), 'catGoods_list', selectionProc, undefined, undefined, 2)
    else if (curVall.parent) addTWnd(localestr('Вибір'), 'catGoods_list', selectionProc, curVall, curVall.parent, 2)
    else addTWnd('Вибір', 'catGoods_list', selectionProc, curVall, undefined, 2)
  }

  const selectionProc = (e, qtt, sum) => {
    if (posted) return
    if ((getGlData() || {}).edit) { saveValue(() => { selectionProc(e, qtt, sum) }); return }
    //менюшка з вибором або в константах чи локально Тихий режим, Запитувати кількість, Запитувати кількість і ціну, Запитувати кількість і суму
    if (!qtt && parseInt(selectionType) > 0) {
      if (e.unit && (e.unit.value === '2' || e.unit === '2')) inputWeight(localestr('Кількість'), localestr('Кількість'), 1, (d) => { selectionProc(e, parseFloat(d || 0)) })
      else inputNumber(localestr('Кількість'), localestr('Кількість'), 1, (d) => { selectionProc(e, parseFloat(d || 0)) })
      return
    }
    if (!qtt) qtt = 1
    let newData = { ...wndData, findText: '', findArr: null }
    let list = newData.list
    let el = list.find(m => m.menu?.id === e.id)
    if (!el) {
      let sum_prc = parseFloat(e.sum_out || 0)
      if (e.price_history_out) sum_prc = parseFloat(getIrgValue(wndData.date, e.price_history_out) || 0)
      if (!sum && parseInt(selectionType) === 2) { setTimeout(() => inputNumber(localestr('Ціна'), localestr('Ціна'), sum_prc, (d) => { selectionProc(e, qtt, parseFloat(d || 0)) }), 50); return }
      if (!sum && parseInt(selectionType) === 3) { setTimeout(() => inputNumber(localestr('Сума'), localestr('Сума'), sum_prc * qtt, (d) => { selectionProc(e, qtt, parseFloat(d || 0)) }), 50); return }
      if (sum && parseInt(selectionType) === 2) sum_prc = sum
      if (sum && parseInt(selectionType) === 3) sum_prc = sum / (qtt || 1)
      let sum_discount = 0
      let discount_mode = 0
      let disc_type = 0
      if (wndData.discount) disc_type = parseInt(wndData.discount.type || 0)
      if (disc_type === 0) { //Звичайна знижка
        if (wndData.discount && wndData.discount.price_history) sum_discount = getIrgValue(wndData.date, wndData.discount.price_history) * sum_prc / 100 * (qtt || 0)
      } else if (disc_type === 2) { //Місячна знижка
        if (wndData.discount && wndData.discount.price_history) sum_discount = (wndData.discount.sum_bal || getIrgValue(wndData.date, wndData.discount.price_history)) - getUsedDiscounts(list, null)
      }
      if (e.disable_discount && parseInt(e.disable_discount)) sum_discount = 0
      if (sum_discount > sum_prc * (qtt || 0)) sum_discount = sum_prc * (qtt || 0)
      if (wndData.discount && wndData.discount.mode) discount_mode = wndData.discount.mode
      if (discount_mode) { sum_prc = sum_prc - sum_discount / (qtt || 1); sum_discount = 0 }
      el = {
        uid: uid(),
        menu: { ...e },
        sum_qtt: qtt.toFixed(3),
        sum_amount: ((sum_prc - sum_discount) * (qtt || 0)).toFixed(2),
        sum_discount: (sum_discount).toFixed(2),
        sum_bruto: (sum_prc * (qtt || 0)).toFixed(2),
        sum_prc: sum_prc.toFixed(2),
        comment: '',
        refuse: selYN[1],
        status: selOrderStatus[1],
        edit: true
      }
      //if(typeof(el.unit)!=='object') el.unit=selUnitType.find(x => x.value === el.unit)
      list.push(el)
    } else if (el.hide) {
      let price_delta = 0
      if (el.modifiers) el.modifiers.forEach(el => price_delta += parseFloat(el.price) || 0)
      let sum_prc = parseFloat(e.sum_out || 0) + price_delta
      if (e.price_history_out) sum_prc = parseFloat(getIrgValue(wndData.date, e.price_history_out) || 0)
      if (!sum && parseInt(selectionType) === 2) { setTimeout(() => inputNumber(localestr('Ціна'), localestr('Ціна'), sum_prc, (d) => { selectionProc(e, qtt, parseFloat(d || 0)) }), 50); return }
      if (!sum && parseInt(selectionType) === 3) { setTimeout(() => inputNumber(localestr('Сума'), localestr('Сума'), sum_prc * qtt, (d) => { selectionProc(e, qtt, parseFloat(d || 0)) }), 50); return }
      if (sum && parseInt(selectionType) === 2) sum_prc = sum
      if (sum && parseInt(selectionType) === 3) sum_prc = sum / (qtt || 1)
      const sum_qtt = qtt
      let sum_bruto = sum_prc * sum_qtt
      let sum_discount = parseFloat(el.sum_discount || 0)
      let discount_mode = 0
      let disc_type = 0
      if (wndData.discount) disc_type = parseInt(wndData.discount.type || 0)
      if (disc_type === 0) { //Звичайна знижка
        if (wndData.discount && wndData.discount.price_history) sum_discount = getIrgValue(wndData.date, wndData.discount.price_history) * sum_prc / 100 * (qtt || 0)
      } else if (disc_type === 2) { //Місячна знижка
        if (wndData.discount && wndData.discount.price_history) sum_discount = getIrgValue(wndData.date, wndData.discount.price_history) - getUsedDiscounts(list, null) - (wndData.discount.sum_bal || 0)
      }
      if (el.menu.disable_discount && parseInt(el.menu.disable_discount)) sum_discount = 0
      if (sum_discount > sum_bruto) sum_discount = sum_bruto
      if (wndData.discount && wndData.discount.mode) discount_mode = wndData.discount.mode
      if (discount_mode) { sum_bruto = sum_bruto - sum_discount; sum_prc = sum_bruto / (qtt || 1); sum_discount = 0 }
      el.sum_prc = sum_prc.toFixed(2)
      el.sum_qtt = sum_qtt.toFixed(3)
      el.sum_bruto = sum_bruto.toFixed(2)
      el.sum_discount = sum_discount.toFixed(2)
      el.sum_amount = (sum_bruto - sum_discount).toFixed(2)
      el.refuse = selYN[1]
      el.status = selOrderStatus[1]
      el.hide = false
      el.edit = true
    } else {
      let price_delta = 0
      if (el.modifiers) el.modifiers.forEach(el => price_delta += parseFloat(el.price) || 0)
      let sum_prc = parseFloat(el.sum_prc || 0) + price_delta
      const sum_qtt = parseFloat(el.sum_qtt || 0) + qtt
      let sum_bruto = sum_prc * sum_qtt
      if (!sum && parseInt(selectionType) === 3) { setTimeout(() => inputNumber(localestr('Сума'), localestr('Сума'), sum_prc * qtt, (d) => { selectionProc(e, qtt, parseFloat(d || 0)) }), 50); return }
      if (sum && parseInt(selectionType) === 3) { sum_bruto = parseFloat(el.sum_amount || 0) + sum; sum_prc = sum_bruto / sum_qtt || 1 }
      let sum_discount = parseFloat(el.sum_discount || 0)
      let discount_mode = 0
      let disc_type = 0
      if (wndData.discount) disc_type = parseInt(wndData.discount.type || 0)
      if (disc_type === 0) { //Звичайна знижка
        if (wndData.discount && wndData.discount.price_history) sum_discount = getIrgValue(wndData.date, wndData.discount.price_history) * sum_prc / 100 * (qtt || 0)
      } else if (disc_type === 2) { //Місячна знижка
        if (wndData.discount && wndData.discount.price_history) sum_discount = getIrgValue(wndData.date, wndData.discount.price_history) - getUsedDiscounts(list, el.uid) - (wndData.discount.sum_bal || 0)
      }
      if (el.menu.disable_discount && parseInt(el.menu.disable_discount)) sum_discount = 0
      if (sum_discount > sum_bruto) sum_discount = sum_bruto
      if (wndData.discount && wndData.discount.mode) discount_mode = wndData.discount.mode
      if (discount_mode) { sum_bruto = sum_bruto - sum_discount; sum_prc = sum_bruto / (qtt || 1); sum_discount = 0 }
      el.sum_prc = sum_prc.toFixed(2)
      el.sum_qtt = sum_qtt.toFixed(3)
      el.sum_bruto = sum_bruto.toFixed(2)
      el.sum_discount = sum_discount.toFixed(2)
      el.sum_amount = (sum_bruto - sum_discount).toFixed(2)
      el.edit = true
    }
    newData.currentCol = { ...el }
    newData.list = list
    if (newData.currFind !== undefined) {
      newData.currFind = undefined
      //Тут фокусування на пошуку 'search'
      setTimeout(() => {
        const el = document.getElementById('search')
        if (el) el.focus()
      }, 200)
    }
    setWndData(newData, true)
    setGlData({ needFocus: -2, lastCol: 0 })
  }

  const removeItem = () => {
    if (posted) return
    //if (edit) return
    if ((getGlData() || {}).edit) { saveValue(() => { removeItem() }); return }
    if (!wndData.currentCol) return
    const currCol = { ...wndData.currentCol, edit: true, hide: true }
    const list = wndData.list
    const idx = list.findIndex(el => el.uid === currCol.uid)
    if (idx === -1) return
    list[idx] = currCol
    let curIdx = idx + 1
    let currentCol = undefined
    for (let i = curIdx; i < list.length; i++) if (!list[i].hide) { currentCol = { ...list[i] }; break }
    if (!currentCol) for (let i = curIdx - 1; i > 0; i--) if (!list[i].hide) { currentCol = { ...list[i] }; break }
    let newData = { ...wndData, list, currentCol }
    setWndData(newData, true)
    setGlData({ needFocus: 0 })
  }

  const editMods = (data) => {
    if (posted) return
    if (edit) return
    if (!wndData.currentCol) return
    if (data) {
      let disc = 0
      let disc_mode = 0
      let disc_type = 0
      if (wndData.discount) {
        disc = parseFloat(wndData.discount.prc)
        if (wndData.discount.price_history) disc = getIrgValue(wndData.date, wndData.discount.price_history)
        disc_mode = parseInt(wndData.discount.mode || 0)
        disc_type = parseInt(wndData.discount.type || 0)
        if (disc_type === 1) disc = 0
      }
      const currCol = { ...wndData.currentCol, edit: true }
      const list = wndData.list
      let price_delta = 0
      data.forEach(el => price_delta += parseFloat(el.price) || 0)
      let price = (parseFloat(currCol.menu.sum_out) || 0)
      if (currCol.menu.price_history_out) price = parseFloat(getIrgValue(wndData.date, currCol.menu.price_history_out) || 0)
      if (!price) price = ((parseFloat(currCol.sum_amount) || 0) + parseFloat(currCol.sum_discount || 0)) / (currCol.sum_qtt || 1)
      price += price_delta
      currCol.sum_prc = price.toFixed(2)
      let sum_bruto = price * parseFloat(currCol.sum_qtt)
      currCol.sum_bruto = sum_bruto.toFixed(2)
      if (disc) {
        if (disc_type === 0) currCol.sum_discount = (parseFloat(currCol.sum_qtt) * price * (disc) / 100).toFixed(2)
        else if (disc_type === 2) currCol.sum_discount = (disc - getUsedDiscounts(list, currCol.uid) - (wndData.discount.sum_bal || 0)).toFixed(2)
        if (disc_mode) {
          sum_bruto -= parseFloat(currCol.sum_discount || 0)
          currCol.discount = ''
        }
      } else currCol.discount = ''
      if (currCol.menu.disable_discount) {
        currCol.discount = ''
      }
      currCol.sum_amount = (sum_bruto - parseFloat(currCol.sum_discount || 0)).toFixed(2)
      currCol.modifiers = data
      const idx = list.findIndex(el => el.uid === currCol.uid)
      if (idx === -1) list.push(currCol)
      else list[idx] = currCol
      let newData = { ...wndData, list, currentCol: currCol }
      setWndData(newData, true)
    }
    else {
      const cont = <Modifiers value={wndData.currentCol.modifiers} data={wndData.currentCol.curr_mods} action={(val) => { editMods(val) }} />
      newTWnd(cont, localestr('Модифікатор'))
    }
  }

  const saveDoc = (d, close = true) => {
    if ((getGlData() || {}).edit) { saveValue(() => { saveDoc(d, close) }); return }
    if (d) {
      loading = false
      const status = d.status
      if (status === 'OffLine') { msg(localestr('Помилка з\'єднання'), localestr('Помилка'), [{ caption: 'OK', action: () => { } }]); return }
      if (status === 'error') { msg(d.msg, localestr('Помилка'), [{ caption: 'OK', action: () => { } }]); return }
      if (wndData.update) wndData.update(d.data)
      tabClose(false)
    } else {
      let data = {}
      if (wndData.edit) {
        if (wndData.id) data.id = wndData.id
        if (wndData.uid) data.uid = wndData.uid
        //if(wndData.posted) data.posted=wndData.posted
        data.header = {
          author: wndData.author, checked: wndData.checked, date: wndData.date, discount: wndData.discount, fiscal: wndData.fiscal, payType: wndData.payType, posted: wndData.posted,
          tabl: wndData.tabl, guests: wndData.guests, comment: (wndData.comment || 'NULL').substring(0, 64), phone: (wndData.phone || 'NULL').substring(0, 10),
          address: (wndData.address || 'NULL').substring(0, 255), name: (wndData.name || 'NULL').substring(0, 64), cert: wndData.cert || { id: 'NULL' }, docType: wndData.docType || '0',
          cashAcc1: wndData.cashAcc1 || { id: 'NULL', name: 'NULL' }, cashAcc2: wndData.cashAcc2 || { id: 'NULL', name: 'NULL' }, sum1: wndData.sum1 || 0, sum2: wndData.sum2 || 0,
          finishTo: (wndData.finishTo || 'NULL').substring(0, 64), status: wndData.status || '0', online: wndData.online || '0', courier: wndData.courier || { id: 'NULL', name: 'NULL' },
          reward: wndData.reward || 0, tip: wndData.tip || 0, additional: wndData.additional || { id: 'NULL', name: 'NULL' }
        }
        if (wndData.marked !== '1' && wndData.marked !== 1) data.header.act = 'post'
        if (!wndData.discount) data.header.discount = { id: 'NULL' }
        else if (!wndData.discount.id) data.header.discount = { id: 'NULL' }
        if (!wndData.tabl) data.header.tabl = { id: 'NULL' }
        if (!wndData.author) data.header.author = { id: 'NULL' }
      }
      let table = wndData.list.filter(el => el.edit)
      table = table.filter(el => !el.hide || el.id)
      if (table.length) {
        if (wndData.id) data.id = wndData.id
        if (wndData.uid) data.uid = wndData.uid
        //if(wndData.posted) data.posted=wndData.posted
        if (wndData.marked !== '1' && wndData.marked !== 1) if (!data.header) data.header = { act: 'post' }
        data.table = table.map(el => {
          let d = {uid: el.uid,
            menu: { id: el.menu.id }, qtt: el.sum_qtt, amount: el.sum_amount, status: el.status.value || 0, discount: el.sum_discount, comment: el.comment, refuse: null,
            mark1: el.mark1, mark2: el.mark2, mark3: el.mark3, mark4: el.mark4, mark5: el.mark5, qtt1: parseInt((parseFloat(el.sum_qtt1) || 0) * 100), qtt2: parseInt((parseFloat(el.sum_qtt2) || 0) * 100),
            qtt3: parseInt((parseFloat(el.sum_qtt3) || 0) * 100), qtt4: parseInt((parseFloat(el.sum_qtt4) || 0) * 100), qtt5: parseInt((parseFloat(el.sum_qtt5) || 0) * 100), excise_mark: el.excise_mark, fiscal: ''
          }
          if (el.fiscal) d.fiscal = el.fiscal.id || ''
          if (el.modifiers) d.modifiers = el.modifiers
          if (el.refuse && el.refuse.value && parseInt(el.refuse.value)) d.refuse = 1
          if (d.refuse && el.reason && el.reason.id) d.reason = { id: el.reason.id }
          else d.reason = { id: 'NULL' }
          if (el.hide) d.act = 'del'
          if (el.id) d.id = el.id
          return d
        })
      }

      if (posted){
        msg(localestr('Не достатньо прав для редагування цього документа'), localestr('Збереження'), [
                { caption: localestr('Відмінити'), action: () => { } },
                { caption: 'Закрити', action: () => { tabClose(false) } }
        ])
        return
      }

      if (Object.keys(data).length) {
        if (parseInt(wndData.posted)) data.posted = 1
        if (parseInt(wndData.marked)) data.marked = 1
      }

      if (parseInt(wndData.posted) && wndData.table) {
        //Перевірити чи треба перерахувати якісь марки
        let marks_old = []
        for (let i = 0; i < wndData.table.length; i++) { //Старі марки
          const item = wndData.table[i]
          if (item.mark1) {
            const idx = marks_old.findIndex(el => el.mark === item.mark1)
            if (idx === -1) marks_old.push({ mark: item.mark1, qtt: parseInt(item.qtt1) })
            else marks_old[idx].qtt += parseInt(item.qtt1)
          }
          if (item.mark2) {
            const idx = marks_old.findIndex(el => el.mark === item.mark2)
            if (idx === -1) marks_old.push({ mark: item.mark2, qtt: parseInt(item.qtt2) })
            else marks_old[idx].qtt += parseInt(item.qtt2)
          }
          if (item.mark3) {
            const idx = marks_old.findIndex(el => el.mark === item.mark3)
            if (idx === -1) marks_old.push({ mark: item.mark3, qtt: parseInt(item.qtt3) })
            else marks_old[idx].qtt += parseInt(item.qtt3)
          }
          if (item.mark4) {
            const idx = marks_old.findIndex(el => el.mark === item.mark4)
            if (idx === -1) marks_old.push({ mark: item.mark4, qtt: parseInt(item.qtt4) })
            else marks_old[idx].qtt += parseInt(item.qtt4)
          }
          if (item.mark5) {
            const idx = marks_old.findIndex(el => el.mark === item.mark5)
            if (idx === -1) marks_old.push({ mark: item.mark5, qtt: parseInt(item.qtt5) })
            else marks_old[idx].qtt += parseInt(item.qtt5)
          }
        }
        let marks_new = []
        for (let i = 0; i < wndData.list.length; i++) { //Нові марки
          const item = wndData.list[i]
          if (item.hide) continue
          if (item.mark1) {
            const idx = marks_new.findIndex(el => el.mark === item.mark1)
            if (idx === -1) marks_new.push({ mark: item.mark1, qtt: parseFloat(item.sum_qtt1) })
            else marks_new[idx].qtt += parseFloat(item.sum_qtt1)
          }
          if (item.mark2) {
            const idx = marks_new.findIndex(el => el.mark === item.mark2)
            if (idx === -1) marks_new.push({ mark: item.mark2, qtt: parseFloat(item.sum_qtt2) })
            else marks_new[idx].qtt += parseFloat(item.sum_qtt2)
          }
          if (item.mark3) {
            const idx = marks_new.findIndex(el => el.mark === item.mark3)
            if (idx === -1) marks_new.push({ mark: item.mark3, qtt: parseFloat(item.sum_qtt3) })
            else marks_new[idx].qtt += parseFloat(item.sum_qtt3)
          }
          if (item.mark4) {
            const idx = marks_new.findIndex(el => el.mark === item.mark4)
            if (idx === -1) marks_new.push({ mark: item.mark4, qtt: parseFloat(item.sum_qtt4) })
            else marks_new[idx].qtt += parseFloat(item.sum_qtt4)
          }
          if (item.mark5) {
            const idx = marks_new.findIndex(el => el.mark === item.mark5)
            if (idx === -1) marks_new.push({ mark: item.mark5, qtt: parseFloat(item.sum_qtt5) })
            else marks_new[idx].qtt += parseFloat(item.sum_qtt5)
          }
        }
        let marks = []
        for (let i = 0; i < marks_old.length; i++) {
          const item = marks_old[i]
          const idx = marks_new.findIndex(el => el.mark === item.mark && parseInt(el.qtt * 100) === item.qtt)
          if (idx === -1) marks.push(item.mark)
        }
        for (let i = 0; i < marks_new.length; i++) {
          const item = marks_new[i]
          let idx = marks.findIndex(el => el === item.mark)
          if (idx !== -1) continue
          idx = marks_old.findIndex(el => el.mark === item.mark && el.qtt === parseInt(item.qtt * 100))
          if (idx === -1) marks.push(item.mark)
        }
        if (marks.length) data.marks = marks
      }

      if (loading) return
      loading = true
      setTimeout(() => { loading = false }, 5000)

      if (!close) {
        if (Object.keys(data).length) {
          data.header.act = '';
          loaddata('action=modOrder&data=' + encodeURIComponent(JSON.stringify(data)), undefined, (dt) => { saveDoc(dt, close) })
        }
        return
      }

      if (Object.keys(data).length && parseInt(wndData.posted)) msg(localestr('Зберегти зміни?'), localestr('Збереження'), [
        { caption: 'OK', action: () => { loaddata('action=modOrder&data=' + encodeURIComponent(JSON.stringify(data)), undefined, (dt) => { saveDoc(dt) }) } },
        { caption: localestr('Відмінити'), action: () => { } }
      ])
      else if (Object.keys(data).length && (!wndData.marked || parseInt(wndData.marked) === 0)) msg(localestr('Зберегти зміни?'), localestr('Збереження'), [
        { caption: localestr('Провести'), action: () => { loaddata('action=modOrder&data=' + encodeURIComponent(JSON.stringify(data)), undefined, (dt) => { saveDoc(dt) }) } },
        { caption: localestr('Зберегти'), action: () => { data.header.act = ''; loaddata('action=modOrder&data=' + encodeURIComponent(JSON.stringify(data)), undefined, (dt) => { saveDoc(dt) }) } },
        { caption: localestr('Відмінити'), action: () => { } }
      ])
      else if ((wndData.posted === '0' || wndData.posted === 0) && (wndData.marked !== '1' && wndData.marked !== 1)) msg(localestr('Провести документ?'), localestr('Проведення'), [
        { caption: localestr('Провести'), action: () => { loaddata('action=postOrder&data=' + encodeURIComponent(JSON.stringify({ id: wndData.id })), undefined, (dt) => { saveDoc(dt) }) } },
        { caption: localestr('Відмінити'), action: () => { } }
      ])
      else if ((wndData.marked !== '1' && wndData.marked !== 1)) msg(localestr('Провести документ?'), localestr('Проведення'), [
        { caption: localestr('Закрити'), action: () => { tabClose(false) } },
        { caption: localestr('Провести'), action: () => { loaddata('action=postOrder&data=' + encodeURIComponent(JSON.stringify({ id: wndData.id })), undefined, (dt) => { saveDoc(dt) }) } }
      ])
      else if (close) tabClose(false)
    }
  }

  const printKitchen = (dep, scr = false) => {
    if (!dep) return
    if (!dep.id) return
    const tblData = wndData.list.filter(el => el.menu.department && el.menu.department.id === dep.id).map(el => {
      const item = { id: el.id, menu: el.menu.menu_name || el.menu.name, comment: el.comment, qtt: el.sum_qtt }
      if (el.modifiers) item.modifiers = el.modifiers.map(it => ({ comment: ' - ' + it.name }))
      return item
    })
    const prnData = { type: 1, screen: scr, data: { department_id: dep.id, author: wndData.author, date: wndData.date, date_loc: (new Date(wndData.date)).toLocaleString().replace(',', ''), id: wndData.id, hall: (wndData.tabl || { owner: { name: '' } }).owner.name, table: (wndData.tabl || { name: '' }).name, docType: wndData.docType, phone: wndData.phone, address: wndData.address, comment: wndData.comment, docTable: tblData } }
    if (wndData.docType && parseInt(wndData.docType) === 1) {
      prnData.data.hall = localestr('Доставка')
      prnData.data.table = '~' + wndData.phone.substring(5)
    }
    loaddata('action=addJobs&data=' + encodeURIComponent(JSON.stringify(prnData)), undefined, () => { })
  }

  const printCheck = (prn = 2, scr = false) => {
    const tblData = wndData.list.filter(el => parseInt(el.refuse.value) === 0).map(el => {
      let modifiers = []
      if (el.modifiers) {
        el.modifiers.forEach(mod => {
          if (mod.price > 0) modifiers.push({ ...mod, price: '+' + mod.price.toFixed(2) })
          else if (mod.price < 0) modifiers.push({ ...mod, price: mod.price.toFixed(2) })
        })
      }
      if (modifiers.length) return { id: el.id, menu: el.menu.menu_name || el.menu.name, price: parseFloat(el.sum_prc || 0).toFixed(2), qtt: parseFloat(el.sum_qtt || 0), amount: (parseFloat(el.sum_amount || 0) + parseFloat(el.sum_discount || 0)).toFixed(2), discount: parseFloat(el.sum_discount || 0).toFixed(2), modifiers }
      return { id: el.id, menu: el.menu.menu_name || el.menu.name, price: parseFloat(el.sum_prc || 0).toFixed(2), qtt: parseFloat(el.sum_qtt || 0), amount: (parseFloat(el.sum_amount || 0) + parseFloat(el.sum_discount || 0)).toFixed(2), discount: parseFloat(el.sum_discount || 0).toFixed(2) }
    })
    let sum = 0
    let sumd = 0
    tblData.forEach(el => {
      sum += parseFloat(el.amount || 0)
      sumd += parseFloat(el.discount || 0)
    })
    const prnData = { type: prn, screen: scr, data: { author: wndData.author, date: wndData.date, date_loc: (new Date(wndData.date)).toLocaleString().replace(',', ''), id: wndData.id, hall: (wndData.tabl || { owner: { name: '' } }).owner.name, table: (wndData.tabl || { name: '' }).name, docType: wndData.docType, payType: wndData.payType, phone: wndData.phone, address: wndData.address, docTable: tblData, sumt: sum.toFixed(2), sumd: sumd.toFixed(2), sum: (sum - sumd).toFixed(2) } }
    if (wndData.docType && parseInt(wndData.docType) === 1) {
      prnData.data.hall = localestr('Доставка')
      prnData.data.table = '~' + (wndData.phone || '').substring(5)
    }
    if (wndData.discount) {
      prnData.data.discount = getIrgValue(wndData.date, wndData.discount.price_history)
      prnData.data.client = wndData.discount.name
    }
    loaddata('action=addJobs&data=' + encodeURIComponent(JSON.stringify(prnData)), undefined, () => { })
  }

  const FiscCopy = (obj, scr = false) => {
    //data: {"id":"9","command":"CheckCopy","NumFiscal":"1202542869","screen":true}
    //console.log(obj)
    const prn = { "id": obj[0], "command": "CheckCopy", "NumFiscal": obj[1], "screen": scr }
    loaddata('action=rroCommand&data=' + JSON.stringify(prn), undefined, (d) => { })
  }

  const prn_req = (act) => {
    msg(localestr('Куди вивести результат?'), localestr('Запитання'), [{ caption: localestr('Екран'), action: () => act(true) }, { caption: localestr('Принтер'), action: () => act() }, { caption: localestr('Відмінити'), action: () => { } }])
  }

  const findItem = (val) => {
    const newData = { ...wndData, findText: val }
    findDlg = false
    newData.findArr = null
    if (val.length > 1) {
      const Arr = catGoods.filter(el => (el.id.indexOf(val) === 0 || (el.name || '').toLowerCase().indexOf(val.toLowerCase()) !== -1 || (el.barcode && el.barcode.indexOf(val) === 0)) && !parseInt(el.marked))
      if (Arr.length > 10) Arr.splice(10)
      newData.findArr = Arr
      if (Arr.length) findDlg = true
      else { newData.findArr = null; findDlg = false }
    }
    setWndData(newData)
  }

  const findClick = (el) => {
    const newData = { ...wndData, findText: '', findArr: null, currFind: -1 }
    findDlg = false
    setWndData(newData)
    selectionProc({ ...el })
  }

  const anyKey = (key) => {
    if (!isActive()) return
    if (key === 'Delete') removeItem()
    else if (key === 'Insert') newItem()
    else if (key === 'F9') copyItem()
    else if (key === 'Escape') cancelEdit()
    else if (key === 'shift_F4') tabClose()
    else if (key === 'F2') filter()
  }

  const objEntries = () => {
    if (wndData.id) {
      const item = { ...wndData, type: 'docOrder' }
      tabNew('repObjEntries', localestr('Проводки') + ' ' + itemToText(item), { object: item }, true)
    }
  }

  const weightClick = async () => {
    if (!edit) return
    if (!wndData.currentCol) return
    const w_type = localStorage.getItem('w_type')
    if (!w_type) {
      msg_arr(localestr('Виберіть модель ваг'), '', [{ caption: 'NT-15', action: () => { localStorage.setItem('w_type', 'NT-15'); weightClick() } }, { caption: 'Ягуар', action: () => { localStorage.setItem('w_type', 'Jaguar'); weightClick() } }])
      return
    }
    if ("serial" in navigator) {
      const ports = await navigator.serial.getPorts();
      let port = ports[0];
      if (!port) port = await navigator.serial.requestPort();
      if (w_type === 'NT-15') {
        try {
          await port.open({ baudRate: 4800, dataBits: 8, stopBits: 1, parity: 'even' });
        } catch (error) {
          console.log(error)
          return;
        }
        let timerId = setTimeout(() => port.close(), 3000)

        const writer = port.writable.getWriter();
        await writer.write(new Uint8Array([0]));
        await writer.write(new Uint8Array([0]));
        await writer.write(new Uint8Array([3]));
        writer.releaseLock();

        let w = '';

        while (port.readable) {
          const reader = port.readable.getReader({ mode: 'byob' });
          let timer2Id = setTimeout(() => reader.releaseLock(), 2000)
          try {
            while (true) {
              let buffer = new ArrayBuffer(16);
              const { value, done } = await reader.read(new Uint8Array(buffer));
              if (done) break;
              if (w.length < 6) {
                for (let i = 0; i < 6; i++) w = String.fromCharCode(value[i]) + w;
              }
              if (value.length < 8) break;
            }
          } catch (error) {
            // Handle |error|…
            console.log(error);
          } finally {
            reader.releaseLock();
            clearTimeout(timer2Id);
            await port.close();
            clearTimeout(timerId);
          }
        }
        setVal('sum_qtt_w', parseInt(w || 0) / 1000)
      } else if (w_type === 'Jaguar') {
        try {
          await port.open({ baudRate: 4800, dataBits: 8, stopBits: 1 });
        } catch (error) {
          console.log(error)
          return;
        }
        let timerId = setTimeout(() => port.close(), 3000)

        const writer = port.writable.getWriter();
        await writer.write(new Uint8Array([80]));
        writer.releaseLock();

        let w = '';

        while (port.readable) {
          const reader = port.readable.getReader({ mode: 'byob' });
          let timer2Id = setTimeout(() => reader.releaseLock(), 2000)
          try {
            while (true) {
              let buffer = new ArrayBuffer(16);
              const { value, done } = await reader.read(new Uint8Array(buffer));
              if (done) break;
              if (w.length < 6) {
                for (let i = 0; i < 6; i++) w += String.fromCharCode(value[i]);
              }
              if (value.length < 8) break;
            }
          } catch (error) {
            // Handle |error|…
            console.log(error);
          } finally {
            reader.releaseLock();
            clearTimeout(timer2Id);
            await port.close();
            clearTimeout(timerId);
          }
        }
        setVal('sum_qtt', parseFloat(w || 0))
      }
    }
  }

  const needFocus = (reset = -1) => {   //Таблиця
    const glData = getGlData() || {}
    const needFocus = glData.needFocus
    const lastCol = glData.lastCol
    if (needFocus === -2) return -2
    if (isActive() === false) return -1
    if (needFocus === undefined) return -1
    if (reset === -1) setGlData({ needFocus: -1 })
    if (reset) setGlData({ needFocus: reset })
    if (reset > 0) setGlData({ lastCol: reset })
    if (needFocus === 0 && lastCol) return lastCol
    return needFocus
  }

  useEffect(() => {
    if (wndData.sorting) sortList(wndData.sorting.dataId, wndData.sorting.sort, wndData.list)
    else sortList('name', 'asc', wndData.list)
    // eslint-disable-next-line 
  }, [wndData.table])

  useEffect(() => {
    if (catGoods === undefined) setTimeout(() => { context.getData('catGoods') }, 10 + Math.floor(Math.random() * 200))
    // eslint-disable-next-line
  }, [context.data['catGoods']])

  function setActive(el) {
    if (edit) return
    if (!el) return
    if (document.activeElement.nodeName === 'INPUT') return
    if (document.activeElement.id === 'doc_cont') return
    if (el.contains(document.activeElement)) return
    el.focus()
  }
  //----------barcode---------
  const getSymbol = (e) => {
    if (e.target.tagName === 'INPUT') return
    if (e.key === 'Insert') { newItem(); return }
    if (edit) return
    if (e.key === 'Enter' || e.which === 13) {
      //console.log(buffer)
      if (!buffer) return
      const items = catGoods.filter(el => el.barcode === buffer)
      if (items.length) {
        buffer = ''
        if (timer) clearInterval(timer)
        timer = null
        if (items.length > 1) {
          const msg_items = items.map(el => ({ caption: (el.parent.name || '') + ' / ' + el.name, action: () => selectionProc(el) }))
          msg_arr(localestr('Виберіть товар'), '', msg_items)
        }
        selectionProc(items[0])
        setTimeout(() => {
          const el = document.getElementById('doc_cont')
          if (el) el.focus()
        }, 200)
      }
      buffer = ''
      if (timer) clearInterval(timer)
      timer = null
      return
    }
    buffer += e.key
    if (!timer) timer = setInterval(() => buffer = '', 500)
  }

  const wndDataList = typeof wndData.list === 'undefined' ? [] : wndData.list
  const sorting = typeof wndData.sorting === 'undefined' ? {} : wndData.sorting
  const showFilter = wndData.showFilter ? <FilterForm filterData={filterData} filter={wndData.filter} setFilter={filter} /> : ''  //+

  let map = new Map()
  let ttlSum = 0
  let ttlDiscount = 0
  wndDataList.forEach(el => {
    if (!el.menu) return
    if (!el.menu.id) return
    if (!map.has(el.menu.department.id)) map.set(el.menu.department.id, el.menu.department)
    if (!map.has(el.menu.department.id)) map.set(el.menu.department.id, el.menu.department)
    if (!el.hide && (!el.refuse || el.refuse.value === '0')) {
      ttlSum += parseFloat(el.sum_amount)
      ttlDiscount += parseFloat(el.sum_discount) || 0
    }

  })
  if (ttlSum !== 0) ttlSum = <div style={{ alignSelf: 'self-end', fontWeight: 'bold' }}>{localestr('Разом') + ': ' + ttlSum.toFixed(2)}</div>
  else ttlSum = ''
  if (ttlDiscount !== 0) ttlDiscount = <div style={{ alignSelf: 'self-end', fontWeight: 'bold' }}>{localestr('Знижка') + ': ' + ttlDiscount.toFixed(2)}</div>
  else ttlDiscount = ''

  const keyHandler = (e) => {
    if (e.key === 'ArrowUp' && wndData.findArr) {
      if (wndData.currFind === undefined || wndData.currFind === -1) setWndData({ ...wndData, currFind: 0 })
      else if (wndData.currFind === 0) setWndData({ ...wndData, currFind: wndData.findArr.length - 1 })
      else setWndData({ ...wndData, currFind: wndData.currFind - 1 })
    }
    else if (e.key === 'ArrowDown' && wndData.findArr) {
      if (wndData.currFind === undefined || wndData.findArr.length - 1 <= wndData.currFind) setWndData({ ...wndData, currFind: 0 })
      else setWndData({ ...wndData, currFind: wndData.currFind + 1 })
    }
    else if (e.key === 'Enter' && wndData.findArr && wndData.findArr.length) {
      if (wndData.currFind === -1 || wndData.currFind === undefined) return//findClick(wndData.findArr[0])
      e.target.blur()
      findClick(wndData.findArr[wndData.currFind])
    }
  }

  let findItems = null
  if (findDlg && wndData.findArr) {
    setTimeout(() => findDlg = false, 30000)
    const items = wndData.findArr.map((el, idx) => {
      let stl = { cursor: 'pointer', fontSize: 'small' }
      if (idx === wndData.currFind) stl.background = '#9E91F7'
      return (
        <div key={idx} style={stl} onClick={() => { findClick(el) }}>{(el.parent.name || '') + ' / ' + el.id + ' - ' + el.name}</div>
      )
    })
    findItems = <div className='no-print' style={{ right: '0px', top: '24px', width: '100%', position: 'absolute', background: '#FFFFFF', zIndex: '100' }}>
      {items}
    </div>
  }

  const menuData = [
    { name: localestr('Налаштування таблиці'), icon: '#b953', action: setHidenCols },
    { name: localestr('Фільтр'), icon: '#b955', action: filter },
    { name: localestr('Проводки документа'), icon: '#postBut', action: objEntries },
  ]

  /*if(wndData.currentCol&&wndData.currentCol.menu&&catGoods){
      const good=catGoods.find(el=>el.id===wndData.currentCol.menu.id)
      if(good&&good.modifiers) console.log(good)
  } */

  let menuData2 = []
  for (let department of map.values()) {
    menuData2.push({ name: localestr('Замовлення для ') + department.name, action: () => prn_req((scr) => printKitchen(department, scr)) })
  }
  menuData2.push({ name: localestr('Рахунок'), action: () => prn_req((scr) => printCheck(2, scr)) })
  menuData2.push({ name: localestr('Чек'), action: () => prn_req((scr) => printCheck(3, scr)) })
  if (wndData.fisc_number) {
    let arr = wndData.fisc_number.split(';')
    for (let i = 0; i < arr.length - 1; i++) {
      let obj = arr[i].split('-')
      menuData2.push({ name: localestr('Фіскальний чек') + ' ' + obj[1], action: () => { prn_req((scr) => FiscCopy(obj, scr)) } })
    }
  }

  let cert = ''
  if (wndData.payType === '4') cert = <EditCtrl Capt={localestr('Сертифікат')} disabled={posted} Value={wndData.cert} typeVal={'catCertificates'} setVal={(d) => { setValue('cert', d) }} width1='80' width2='80' />

  let tblContMob = <div style={{ margin: '2px 0', display: 'inherit', gap: '2px' }}>
    <EditCtrl Capt={localestr('Зал')} Value={wndData.tabl ? wndData.tabl.owner : null} typeVal={'catHalls'} setVal={(d) => { setValue('hall', d) }} width1='25' width2='20' disabled={true} />
    <EditCtrl Capt={localestr('Стіл')} disabled={posted} Value={wndData.tabl} typeVal={'catTables'} setVal={(d) => { setValue('tabl', d) }} width1='30' width2='20' />
    <EditCtrl Capt={localestr('Кількість гостей')} disabled={posted} Value={wndData.guests} typeVal={'number'} setVal={(d) => { setValue('guests', d) }} width1='80' width2='1' />
  </div>

  if (wndData.docType && parseInt(wndData.docType) === 1) {
    let courier_cont = null
    if (sysConst.constXprs || true) courier_cont = <>
      <div style={{ margin: '2px 0', display: 'flex', flexDirection: 'row', gap: '5px' }}>
        <EditCtrl Capt={localestr('Кур\'єр')} disabled={posted} Value={wndData.courier} typeVal={'catUsers'} setVal={(d) => { setValue('courier', d) }} width1='54' width2='100' />
        <EditCtrl Capt={localestr('Винагорода')} disabled={posted} Value={wndData.reward} typeVal={'number'} setVal={(d) => { setValue('reward', d) }} width1='90' width2='70' />
      </div>
    </>
    tblContMob = <div style={{ margin: '2px 0', display: 'inherit', flexDirection: 'column', flexWrap: 'nowrap' }}>
      <div style={{ margin: '2px 0', display: 'flex', flexDirection: 'row', gap: '5px' }}>
        <EditCtrl Capt={localestr('Телефон')} disabled={posted} Value={wndData.phone} typeVal={'text'} setVal={(d) => { setValue('phone', d) }} width1='64' width2='92' />
        <EditCtrl Capt={localestr('Ім\'я')} disabled={posted} Value={wndData.name} typeVal={'text'} setVal={(d) => { setValue('name', d) }} width1='28' width2='124' />
      </div>
      <div style={{ margin: '2px 0', display: 'flex', flexDirection: 'row', gap: '5px' }}>
        <EditCtrl Capt={localestr('Адреса')} disabled={posted} Value={wndData.address} typeVal={'text'} setVal={(d) => { setValue('address', d) }} width1='54' width2='100' />
        <EditCtrl Capt={localestr('Підготувати до')} disabled={posted} Value={wndData.finishTo} typeVal={'text'} setVal={(d) => { setValue('finishTo', d) }} width1='120' width2='40' />
      </div>
      {courier_cont}
    </div>
  }
  if (wndData.docType && parseInt(wndData.docType) === 2) tblContMob = <div style={{ margin: '2px 0', display: 'inherit', flexWrap: 'wrap' }}>
    <EditCtrl Capt={localestr('Телефон')} disabled={posted} Value={wndData.phone} typeVal={'text'} setVal={(d) => { setValue('phone', d) }} width1='64' width2='100' />
    <div style={{ minWidth: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
    <EditCtrl Capt={localestr('Ім\'я')} disabled={posted} Value={wndData.name} typeVal={'text'} setVal={(d) => { setValue('name', d) }} width1='30' width2='145' />
    <div style={{ minWidth: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
    <EditCtrl Capt={localestr('Підготувати до')} disabled={posted} Value={wndData.finishTo} typeVal={'text'} setVal={(d) => { setValue('finishTo', d) }} width1='120' width2='128' />
    <div style={{ minWidth: '8px', display: 'inline-block', flexGrow: 400, maxWidth: '16px' }}></div>
  </div>

  //сумарна ширина 792px це розраховано на екран 1024px
  let tblCont = <div style={{ margin: '2px 0', display: 'inherit' }}>
    <EditCtrl Capt={localestr('Зал')} Value={wndData.tabl ? wndData.tabl.owner : null} typeVal={'catHalls'} setVal={(d) => { setValue('hall', d) }} width1='40' width2='130' disabled={true} />
    <div style={{ minWidth: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
    <EditCtrl Capt={localestr('Стіл')} disabled={posted} Value={wndData.tabl} typeVal={'catTables'} setVal={(d) => { setValue('tabl', d) }} width1='45' width2='117' />
    <div style={{ minWidth: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
    <EditCtrl Capt={localestr('Кількість гостей')} disabled={posted} Value={wndData.guests} typeVal={'number'} setVal={(d) => { setValue('guests', d) }} width1='118' width2='42' />
    <div style={{ minWidth: '284px', display: 'inline-block', flexGrow: 100, maxWidth: '568px' }}></div>

  </div>
  if (wndData.docType && parseInt(wndData.docType) === 1) {
    let courier_cont = null
    if (sysConst.constXprs || true) courier_cont = <div style={{ margin: '2px 0', display: 'inherit', flexWrap: 'nowrap' }}>
      <EditCtrl Capt={localestr('Кур\'єр')} disabled={posted} Value={wndData.courier} typeVal={'catUsers'} setVal={(d) => { setValue('courier', d) }} width1='54' width2='190' />
      <div style={{ minWidth: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
      <EditCtrl Capt={localestr('Винагорода')} disabled={posted} Value={wndData.reward} typeVal={'number'} setVal={(d) => { setValue('reward', d) }} width1='110' width2='106' />
    </div>
    tblCont = <><div style={{ margin: '2px 0', display: 'inherit', flexWrap: 'nowrap' }}>
      <EditCtrl Capt={localestr('Телефон')} disabled={posted} Value={wndData.phone} typeVal={'text'} setVal={(d) => { setValue('phone', d) }} width1='64' width2='92' />
      <div style={{ minWidth: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
      <EditCtrl Capt={localestr('Ім\'я')} disabled={posted} Value={wndData.name} typeVal={'text'} setVal={(d) => { setValue('name', d) }} width1='28' width2='124' />
      <div style={{ minWidth: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
      <EditCtrl Capt={localestr('Адреса')} disabled={posted} Value={wndData.address} typeVal={'text'} setVal={(d) => { setValue('address', d) }} width1='54' width2='190' />
      <div style={{ minWidth: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
      <EditCtrl Capt={localestr('Підготувати до')} disabled={posted} Value={wndData.finishTo} typeVal={'text'} setVal={(d) => { setValue('finishTo', d) }} width1='110' width2='106' />
    </div>{courier_cont}</>
  }
  if (wndData.docType && parseInt(wndData.docType) === 2) tblCont = <div style={{ margin: '2px 0', display: 'inherit', flexWrap: 'wrap' }}>
    <EditCtrl Capt={localestr('Телефон')} disabled={posted} Value={wndData.phone} typeVal={'text'} setVal={(d) => { setValue('phone', d) }} width1='64' width2='100' />
    <div style={{ minWidth: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
    <EditCtrl Capt={localestr('Ім\'я')} disabled={posted} Value={wndData.name} typeVal={'text'} setVal={(d) => { setValue('name', d) }} width1='30' width2='145' />
    <div style={{ minWidth: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
    <EditCtrl Capt={localestr('Підготувати до')} disabled={posted} Value={wndData.finishTo} typeVal={'text'} setVal={(d) => { setValue('finishTo', d) }} width1='110' width2='128' />
    <div style={{ minWidth: '8px', display: 'inline-block', flexGrow: 400, maxWidth: '16px' }}></div>
  </div>

  let modBtn = ''
  if (wndData.currentCol && wndData.currentCol.menu && wndData.currentCol.curr_mods)
    modBtn = <div tabIndex='0' className='toolBarItem' title={localestr('Модифікатори')}
      onClick={() => editMods()}
      onKeyUp={(e) => { if (e.key === 'Enter') editMods() }}><img src={icon + '#checkBut'} alt={localestr('Модифікатори')} /></div>


  let weightBtn = null
  //if(wndData.currentCol && wndData.currentCol.good && wndData.currentCol.good.unit && parseInt(wndData.currentCol.good.unit.value)===2) weightBtn=
  if (edit && wndData.currentCol && wndData.currentCol.unit && parseInt(wndData.currentCol.unit.value) === 2) weightBtn =
    <div id='modal' tabIndex='0' onClick={() => { weightClick() }} onKeyUp={(e) => { if (e.key === 'Enter') weightClick() }}
      style={{ alignSelf: 'center', lineHeight: '30px', height: '30px', width: '95px', padding: '0px 2px 0 6px', color: '#FFF', userSelect: 'none', cursor: 'pointer', background: 'url(' + icon + '#btn95v) no-repeat', backgroundSize: '103px 30px' }}>
      <img style={{ width: '12px', height: '24px', verticalAlign: 'middle', marginLeft: '12px', marginRight: '8px' }} src={icon + '#run'} alt={localestr('Вага')} />
      {localestr('Вага')}
    </div>

  const userData_status = [{ name: localestr('Нове'), value: '0' }, { name: localestr('Виданий рахунок'), value: '1' }]
  if (sysConst.constXprs && wndData.docType === '1') {
    userData_status.push({ name: localestr('В доставці'), value: '2' })
    userData_status.push({ name: localestr('Оплачено в доставці'), value: '3' })
  }
  const userData_online = [{ name: localestr('Введене персоналом'), value: '0' }, { name: localestr('Зроблено гостем'), value: '1' }, { name: localestr('Оплачено гостем'), value: '2' }]

  if (window.innerWidth < 425) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', margin: '4px 5px 0 5px', height: 'calc(100% - 30px)', outline: 'none', width: 'calc(100% - 40px)' }} tabIndex='0' id='doc_cont'
        ref={el => { setActive(el); return targetRef }} onKeyUp={getSymbol}>
        <div style={{ margin: '2px 0', display: 'inherit', flexDirection: 'column' }}>
          <div style={{ margin: '2px 0', display: 'inherit', flexDirection: 'row', gap: '5px' }}>
            <EditCtrl Capt={localestr('Чек') + ' №'} Value={wndData.id} typeVal={'text'} setVal={(d) => { setValue('id', d) }} width1='55' width2='54' disabled={true} />
            <EditCtrl Capt={localestr('від')} disabled={posted} Value={new Date(wndData.date)} typeVal={'datetime'} setVal={(d) => { setValue('date', d) }} width1='22' width2='184' />
          </div>
          <div style={{ margin: '2px 0', display: 'inherit', flexDirection: 'row', gap: '5px' }}>
            <EditCtrl Capt={localestr('Вид оплати')} disabled={posted} Value={wndData.payType} typeVal={'selPayTypes'} setVal={(d) => { setValue('payType', d) }} width1='90' width2='50' />
            <EditCtrl Capt={localestr('Фіскальний')} disabled={posted} Value={wndData.fiscal} typeVal={'selFiscalTypes2'} setVal={(d) => { setValue('fiscal', d) }} width1='89' width2='50' />
          </div>
        </div>

        <Panel caption={''} width={180} open={wndData.p_head === undefined ? true : wndData.p_head} setOpen={d => setWndData({ ...wndData, p_head: d })}>
          <div style={{ margin: '2px 0', display: 'flex', flexDirection: 'column' }}>
            <EditCtrl Capt={localestr('Вид замовлення')} disabled={posted} Value={wndData.docType} typeVal={'selDocType'} setVal={(d) => { setValue('docType', d) }} width1='124' width2='102' />
            <EditCtrl Capt={localestr('Дисконтна картка')} disabled={posted} Value={wndData.discount} typeVal={'catDiscounts'} setVal={(d) => { setValue('discount', d) }} width1='140' width2='170' />
            <EditCtrl Capt={localestr('Коментар')} disabled={posted} Value={wndData.comment} typeVal={'text'} setVal={(d) => { setValue('comment', d) }} width1='80' width2='172' />
          </div>

          <div style={{ margin: '2px 0', display: 'inherit', flexDirection: 'column' }}>
          <EditCtrl Capt={localestr('Статус замовлення')} disabled={posted} Value={wndData.status}
            typeVal={'selUserType'} userData={userData_status} setVal={(d) => { setValue('status', d) }} width1='150' width2='55' />
          <div style={{ margin: '2px 0', display: 'flex', gap: '5px' }} >
            <EditCtrl Capt={localestr('додатково')} disabled={posted} Value={wndData.online}
              typeVal={'selUserType'} userData={userData_online} setVal={(d) => { setValue('online', d) }} width1='80' width2='55' />
            {/* Тут ще додаткова аналытика (місцеві іногородні) */}
            <EditCtrl Capt={localestr('Чайові')} disabled={posted} Value={wndData.tip}
              typeVal={'number'} setVal={(d) => { setValue('tip', d) }} width1='52' width2='55' />
          </div>

        </div>

        {tblContMob}{cert}

        <div style={{ margin: '2px 0', display: 'flex', flexDirection: 'column' }}>
          <div style={{ margin: '2px 0', display: 'flex', flexDirection: 'row', gap: '5px' }}>
            <EditCtrl Capt={localestr('Каса')} disabled={posted} Value={wndData.cashAcc1} typeVal={'catCashAccs'} setVal={(d) => { setValue('cashAcc1', d) }} width1='38' width2='70' />
            <EditCtrl Capt={localestr('Сума готівкою')} disabled={posted} Value={wndData.sum1} typeVal={'number'} setVal={(d) => { setValue('sum1', d) }} width1='110' width2='70' />
          </div>
          <div style={{ margin: '2px 0', display: 'flex', flexDirection: 'column', gap: '5px' }}>
            <EditCtrl Capt={localestr('Картковий рахунок')} disabled={posted} Value={wndData.cashAcc2} typeVal={'catCashAccs'} setVal={(d) => { setValue('cashAcc2', d) }} width1='150' width2='114' />
            <EditCtrl Capt={localestr('Сума карткою')} disabled={posted} Value={wndData.sum2} typeVal={'number'} setVal={(d) => { setValue('sum2', d) }} width1='108' width2='70' />
          </div>

        </div>
        </Panel>


        
        <div className='toolBar no-print'>
          <div tabIndex='0' className='toolBarItem' title={localestr('Додати') + ' (Ins)'}
            onClick={() => newItem()}
            onKeyUp={(e) => { if (e.key === 'Enter') newItem() }}><img src={icon + '#addBut'} alt={localestr('Додати')} /></div>
          <div tabIndex='0' className='toolBarItem' title={localestr('Копіювати') + ' (F9)'}
            onClick={() => copyItem()} onKeyUp={(e) => { if (e.key === 'Enter') copyItem() }}
          ><img src={icon + '#copyBut'} alt={localestr('Копіювати')} /></div>

          <div tabIndex='0' className='toolBarItem' title={localestr('Видалити') + ' (Del)'}
            onClick={() => removeItem()}
            onKeyUp={(e) => { if (e.key === 'Enter') removeItem() }}><img src={icon + '#delBut'} alt={localestr('Видалити')} /></div>

          <div tabIndex='0' className='toolBarItem' title={localestr('Автофільтр')}
            onClick={() => showHideFilter()}
            onKeyUp={(e) => { if (e.key === 'Enter') showHideFilter() }}><img src={icon + '#filtBut'} alt={localestr('Автофільтр')} /></div>
          <div tabIndex='0' className='toolBarSeparator'></div>
          {weightBtn}
          {modBtn}

          <div tabIndex='0' onClick={() => { selectionClick() }} onKeyUp={(e) => { if (e.key === 'Enter') selectionClick() }}
            style={{ alignSelf: 'center', lineHeight: '30px', height: '30px', width: '95px', padding: '0px 2px 0 6px', color: '#FFF', userSelect: 'none', cursor: 'pointer', background: 'url(' + icon + '#btn95v) no-repeat', backgroundSize: '102px 30px' }}>
            <img style={{ width: '24px', height: '24px', verticalAlign: 'middle' }} src={icon + '#sel'} alt={localestr('Підбір')} />&nbsp;
            {localestr('Підбір')}
          </div>
          <div tabIndex='0' className='toolBarSeparator'></div>
          <div style={{ position: 'relative', padding: '3px' }}>
            <input id='search' type='text' value={wndData.findText || ''} onChange={(e) => { findItem(e.target.value) }} onKeyUp={keyHandler}
              onBlur={() => { setTimeout(() => { if (findDlg) setWndData({ ...wndData, findArr: null, currFind: undefined }) }, 200) }} placeholder={localestr('пошук')}
              style={{ width: 'calc(100% - 28px)', padding: '0 22px 0 2px', flexShrink: '0', fontSize: 'inherit', fontFamily: 'inherit' }} />
            <img src={icon + '#b956'} alt='' style={{ position: 'absolute', right: '7px', top: '9px', width: '14px', height: '14px', opacity: 0.5 }} />
            {findItems}
          </div>
          <div style={{ flexGrow: '10' }}></div>
          <div className='toolBarItem' title={localestr('Додатково')}><Menu data={menuData}>
            <img className='toolBarIcon' src={icon + '#dnBut'} alt='' />
          </Menu></div>
        </div>
        <UniTable haveHeader={true} colsArr={cols} data={wndDataList} currCol={{ ...wndData.currentCol, edit: isActive2 }} sorting={sorting} filter={wndData.filter} filtArr={filterData} showFilter={wndData.showAFilter} clickSort={sortList} clickHandle={(item) => { setCol(item) }} openHandle={editClick} keyHandle={anyKey} saveHandle={saveValue} cancelHandle={cancelEdit} setFilter={setFilter} tblPos={tblPos} needFocus={needFocus} />
        <div style={{ display: 'flex' }}>
          <div className='no-print' style={{ margin: '2px 0', display: 'inherit' }}>
            <div style={{ width: '64px', display: 'inline-block', verticalAlign: 'bottom' }} className={'key_btn'} onClick={() => saveDoc()}><div style={{ height: '30px', lineHeight: '30px', display: 'block' }}>OK</div></div>
            <div style={{ width: '64px', display: 'inline-block', verticalAlign: 'bottom', overflow: 'visible' }} className={'key_btn'}><div style={{ height: '30px', lineHeight: '30px', display: 'block' }}><Menu stl={{}} data={menuData2} left={true} bottom={true}>{localestr('Друк')}</Menu></div></div>
          </div>
          <div style={{ flexGrow: '10' }}></div>
          <div>{ttlDiscount}{ttlSum}</div>
        </div>
        <div className='no-print'>{showFilter}</div>
      </div>
    )
  }

  return (

    <div style={{ display: 'flex', flexDirection: 'column', margin: '4px 0', height: 'calc(100% - 10px)', outline: 'none', width: 'calc(100% - 6px)' }} tabIndex='0' id='doc_cont'
      ref={el => { setActive(el); return targetRef }} onKeyUp={getSymbol}>
      <div style={{ margin: '2px 0', display: 'inherit' }}>
        <EditCtrl Capt={localestr('Чек') + ' №'} Value={wndData.id} typeVal={'text'} setVal={(d) => { setValue('id', d) }} width1='50' width2='54' disabled={true} />
        <div style={{ minWidth: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
        <EditCtrl Capt={localestr('від')} disabled={posted} Value={new Date(wndData.date)} typeVal={'datetime'} setVal={(d) => { setValue('date', d) }} width1='22' width2='184' />
        <div style={{ minWidth: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
        <EditCtrl Capt={localestr('Вид оплати')} disabled={posted} Value={wndData.payType} typeVal={'selPayTypes'} setVal={(d) => { setValue('payType', d) }} width1='84' width2='146' />
        <div style={{ minWidth: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
        <EditCtrl Capt={localestr('Фіскальний')} disabled={posted} Value={wndData.fiscal} typeVal={'selFiscalTypes2'} setVal={(d) => { setValue('fiscal', d) }} width1='84' width2='144' />
      </div>
      <div style={{ margin: '2px 0', display: 'inherit' }}>
        <EditCtrl Capt={localestr('Вид замовлення')} disabled={posted} Value={wndData.docType} typeVal={'selDocType'} setVal={(d) => { setValue('docType', d) }} width1='124' width2='102' />
        <div style={{ minWidth: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
        <EditCtrl Capt={localestr('Дисконтна картка')} disabled={posted} Value={wndData.discount} typeVal={'catDiscounts'} setVal={(d) => { setValue('discount', d) }} width1='134' width2='170' />
        <div style={{ minWidth: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
        <EditCtrl Capt={localestr('Коментар')} disabled={posted} Value={wndData.comment} typeVal={'text'} setVal={(d) => { setValue('comment', d) }} width1='74' width2='172' />
      </div>
      <div style={{ margin: '2px 0', display: 'inherit' }}>
        <EditCtrl Capt={localestr('Статус замовлення')} disabled={posted} Value={wndData.status}
          typeVal={'selUserType'} userData={userData_status} setVal={(d) => { setValue('status', d) }} width1='134' width2='55' />
        <div style={{ minWidth: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
        <EditCtrl Capt={localestr('додатково')} disabled={posted} Value={wndData.online}
          typeVal={'selUserType'} userData={userData_online} setVal={(d) => { setValue('online', d) }} width1='76' width2='55' />
        <div style={{ minWidth: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
        {/* Тут ще додаткова аналытика (місцеві іногородні) */}
        <EditCtrl Capt={localestr('Чайові')} disabled={posted} Value={wndData.tip}
          typeVal={'number'} setVal={(d) => { setValue('tip', d) }} width1='52' width2='55' />
      </div>
      {tblCont}{cert}
      <div style={{ margin: '2px 0', display: 'inherit' }}>
        <EditCtrl Capt={localestr('Каса')} disabled={posted} Value={wndData.cashAcc1} typeVal={'catCashAccs'} setVal={(d) => { setValue('cashAcc1', d) }} width1='38' width2='114' />
        <div style={{ minWidth: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
        <EditCtrl Capt={localestr('Сума готівкою')} disabled={posted} Value={wndData.sum1} typeVal={'number'} setVal={(d) => { setValue('sum1', d) }} width1='110' width2='70' />
        <div style={{ minWidth: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
        <EditCtrl Capt={localestr('Картковий рахунок')} disabled={posted} Value={wndData.cashAcc2} typeVal={'catCashAccs'} setVal={(d) => { setValue('cashAcc2', d) }} width1='144' width2='114' />
        <div style={{ minWidth: '8px', display: 'inline-block', flexGrow: 4, maxWidth: '16px' }}></div>
        <EditCtrl Capt={localestr('Сума карткою')} disabled={posted} Value={wndData.sum2} typeVal={'number'} setVal={(d) => { setValue('sum2', d) }} width1='108' width2='70' />
      </div>
      <div className='toolBar no-print'>
        <div tabIndex='0' className='toolBarItem' title={localestr('Додати') + ' (Ins)'}
          onClick={() => newItem()}
          onKeyUp={(e) => { if (e.key === 'Enter') newItem() }}><img src={icon + '#addBut'} alt={localestr('Додати')} /></div>
        <div tabIndex='0' className='toolBarItem' title={localestr('Копіювати') + ' (F9)'}
          onClick={() => copyItem()} onKeyUp={(e) => { if (e.key === 'Enter') copyItem() }}
        ><img src={icon + '#copyBut'} alt={localestr('Копіювати')} /></div>

        <div tabIndex='0' className='toolBarItem' title={localestr('Видалити') + ' (Del)'}
          onClick={() => removeItem()}
          onKeyUp={(e) => { if (e.key === 'Enter') removeItem() }}><img src={icon + '#delBut'} alt={localestr('Видалити')} /></div>

        <div tabIndex='0' className='toolBarItem' title={localestr('Автофільтр')}
          onClick={() => showHideFilter()}
          onKeyUp={(e) => { if (e.key === 'Enter') showHideFilter() }}><img src={icon + '#filtBut'} alt={localestr('Автофільтр')} /></div>
        <div tabIndex='0' className='toolBarSeparator'></div>
        {weightBtn}
        {modBtn}

        <div tabIndex='0' onClick={() => { selectionClick() }} onKeyUp={(e) => { if (e.key === 'Enter') selectionClick() }}
          style={{ alignSelf: 'center', lineHeight: '30px', height: '30px', width: '95px', padding: '0px 2px 0 6px', color: '#FFF', userSelect: 'none', cursor: 'pointer', background: 'url(' + icon + '#btn95v) no-repeat', backgroundSize: '102px 30px' }}>
          <img style={{ width: '24px', height: '24px', verticalAlign: 'middle' }} src={icon + '#sel'} alt={localestr('Підбір')} />&nbsp;
          {localestr('Підбір')}
        </div>
        <div tabIndex='0' className='toolBarSeparator'></div>
        <div style={{ position: 'relative', padding: '3px' }}>
          <input id='search' type='text' value={wndData.findText || ''} onChange={(e) => { findItem(e.target.value) }} onKeyUp={keyHandler}
            onBlur={() => { setTimeout(() => { if (findDlg) setWndData({ ...wndData, findArr: null, currFind: undefined }) }, 200) }} placeholder={localestr('пошук')}
            style={{ width: 'calc(100% - 28px)', padding: '0 22px 0 2px', flexShrink: '0', fontSize: 'inherit', fontFamily: 'inherit' }} />
          <img src={icon + '#b956'} alt='' style={{ position: 'absolute', right: '7px', top: '9px', width: '14px', height: '14px', opacity: 0.5 }} />
          {findItems}
        </div>
        <div style={{ flexGrow: '10' }}></div>
        <div className='toolBarItem' title={localestr('Додатково')}><Menu data={menuData}>
          <img className='toolBarIcon' src={icon + '#dnBut'} alt='' />
        </Menu></div>
      </div>
      <UniTable haveHeader={true} colsArr={cols} data={wndDataList} currCol={{ ...wndData.currentCol, edit: isActive2 }} sorting={sorting} filter={wndData.filter} filtArr={filterData} showFilter={wndData.showAFilter} clickSort={sortList} clickHandle={(item) => { setCol(item) }} openHandle={editClick} keyHandle={anyKey} saveHandle={saveValue} cancelHandle={cancelEdit} setFilter={setFilter} tblPos={tblPos} needFocus={needFocus} />
      <div style={{ display: 'flex' }}>
        <div className='no-print' style={{ margin: '2px 0', display: 'inherit' }}>
          <div style={{ width: '64px', display: 'inline-block', verticalAlign: 'bottom' }} className={'key_btn'} onClick={() => saveDoc()}><div style={{ height: '30px', lineHeight: '30px', display: 'block' }}>OK</div></div>
          <div style={{ width: '64px', display: 'inline-block', verticalAlign: 'bottom', overflow: 'visible' }} className={'key_btn'}><div style={{ height: '30px', lineHeight: '30px', display: 'block' }}><Menu stl={{}} data={menuData2} left={true} bottom={true}>{localestr('Друк')}</Menu></div></div>
        </div>
        <div style={{ flexGrow: '10' }}></div>
        <div>{ttlDiscount}{ttlSum}</div>
      </div>
      <div className='no-print'>{showFilter}</div>
    </div>
  )

}

export default DocOrderEdit